import React from 'react';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  color?: 'primary' | 'white';
  text?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  size = 'md', 
  color = 'primary',
  text 
}) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-6 h-6',
    lg: 'w-8 h-8'
  };

  const colorClasses = {
    primary: 'border-[#0FFF55]',
    white: 'border-white'
  };

  return (
    <div className="flex items-center justify-center space-x-3">
      <div 
        className={`${sizeClasses[size]} border-2 ${colorClasses[color]} border-t-transparent rounded-full animate-spin`}
      />
      {text && (
        <span className={`text-sm font-medium ${
          color === 'primary' ? 'text-[#0FFF55]' : 'text-white'
        }`}>
          {text}
        </span>
      )}
    </div>
  );
};

export default LoadingSpinner; 